export type SessionDatas = {
  webapiBaseUrl: string;
};

// 初期値定義
export const SessionDatasInitVal: SessionDatas = {
  webapiBaseUrl: `${import.meta.env.VITE_EP_WEBAPI_AP || ''}/${import.meta.env.VITE_ENV}`
};
